<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-type-modal-list">
            <h2>Deseja excluir o Tipo de Medicamento?</h2>
         </div>
         
         <div class="body-type-modal-list">
            Tem certeza que deseja excluir esse Tipo de Medicamento? Todos os dados serão perdidos.
         </div>
         <div class="footer-type-modal-list">
            <button mat-button class="btn-primary block" (click)="clickDelete()">
                <span *ngIf="isLoading == false">Sim, excluir</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>
